import { createElement } from 'react';
import { FaSun } from 'react-icons/fa';
import { BsMoon } from 'react-icons/bs';
var classes = {
  "container": "_1Lxpd",
  "toggle": "_2SrV2",
  "toggle__slide": "_5CjZJ",
  "toggle__moon": "_aZqFb",
  "toggle__sunlight": "_NR7_U",
  "dark": "_3QbTe",
  "small": "_1YEqb"
};

require('./index.css');

var DarkModeToggler = function DarkModeToggler(_ref) {
  var onClick = _ref.onClick,
      isDark = _ref.isDark,
      size = _ref.size,
      border = _ref.border;
  var toggleCSS = [classes.toggle];
  size === 'small' && toggleCSS.push(classes.small);
  isDark === 'dark' && toggleCSS.push(classes.dark);
  return createElement("div", {
    style: {
      borderColor: isDark === 'dark' ? border : ''
    },
    className: toggleCSS.join(' '),
    onClick: onClick
  }, createElement("div", {
    className: classes.toggle__slide
  }), createElement("span", {
    className: classes.toggle__sunlight
  }, createElement(FaSun, null)), createElement("span", {
    className: classes.toggle__moon
  }, createElement(BsMoon, null)));
};

export { DarkModeToggler };